(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["electric-nail-grinder-blue-offer"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const selector = '#wishcrate-listicle[data-ng-root]';
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

    const initialize = (root) => {
      if (!root || root.dataset.ngReady === 'true') return;
      root.dataset.ngReady = 'true';
      root.classList.add('is-enhanced');
      document.body.classList.add('twc-ng-landing-active');

      const revealItems = [...root.querySelectorAll('.twc-ng__reveal')];
      if (reducedMotion.matches || !('IntersectionObserver' in window)) {
        revealItems.forEach((item) => item.classList.add('is-visible'));
      } else {
        const revealObserver = new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting) return;
            entry.target.classList.add('is-visible');
            revealObserver.unobserve(entry.target);
          });
        }, { threshold: 0.1, rootMargin: '0px 0px -32px' });
        revealItems.forEach((item) => revealObserver.observe(item));
      }

      let rootVisible = true;
      const updateMotion = () => {
        root.classList.toggle('is-motion-running', rootVisible && !document.hidden && !reducedMotion.matches);
      };

      if ('IntersectionObserver' in window) {
        const rootObserver = new IntersectionObserver((entries) => {
          rootVisible = entries[0].isIntersecting;
          updateMotion();
        }, { threshold: 0.01 });
        rootObserver.observe(root);
      }

      const animatedItems = [...root.querySelectorAll('[data-ng-animated]')];
      if ('IntersectionObserver' in window) {
        const animatedObserver = new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
            entry.target.classList.toggle('is-in-view', entry.isIntersecting);
          });
        }, { threshold: 0.12 });
        animatedItems.forEach((item) => animatedObserver.observe(item));
      } else {
        animatedItems.forEach((item) => item.classList.add('is-in-view'));
      }

      document.addEventListener('visibilitychange', updateMotion);
      reducedMotion.addEventListener?.('change', updateMotion);
      updateMotion();

      const motionImages = [...root.querySelectorAll('[data-ng-motion-image]')];
      const syncMotionImages = () => {
        motionImages.forEach((image) => {
          const animatedSource = image.dataset.animatedSrc;
          const posterSource = image.dataset.posterSrc;
          const shouldAnimate = image.dataset.ngMotionVisible === 'true' && !document.hidden && !reducedMotion.matches;
          const nextSource = shouldAnimate ? animatedSource : posterSource;
          if (nextSource && image.getAttribute('src') !== nextSource) image.setAttribute('src', nextSource);
        });
      };

      if ('IntersectionObserver' in window) {
        const motionImageObserver = new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
            entry.target.dataset.ngMotionVisible = entry.isIntersecting ? 'true' : 'false';
          });
          syncMotionImages();
        }, { threshold: 0.05, rootMargin: '120px 0px' });
        motionImages.forEach((image) => {
          image.dataset.ngMotionVisible = 'false';
          motionImageObserver.observe(image);
        });
      } else {
        motionImages.forEach((image) => {
          image.dataset.ngMotionVisible = 'true';
        });
      }

      document.addEventListener('visibilitychange', syncMotionImages);
      reducedMotion.addEventListener?.('change', syncMotionImages);
      syncMotionImages();

      root.querySelectorAll('[data-ng-carousel]').forEach((carousel) => {
        const track = carousel.querySelector('[data-ng-track]');
        const slides = [...carousel.querySelectorAll('[data-ng-slide]')];
        const dots = [...carousel.querySelectorAll('[data-ng-dot]')];
        if (!track || slides.length < 2) return;

        let index = 0;
        let timer = null;
        let visible = false;
        let pointerStart = null;
        let paused = false;
        const delay = Number(carousel.dataset.delay) || 5200;

        const stop = () => {
          if (timer) window.clearTimeout(timer);
          timer = null;
        };

        const schedule = () => {
          stop();
          if (!visible || paused || document.hidden || reducedMotion.matches) return;
          timer = window.setTimeout(() => show(index + 1, true), delay);
        };

        const show = (nextIndex, shouldSchedule = true) => {
          index = (nextIndex + slides.length) % slides.length;
          track.style.transform = `translate3d(-${index * 100}%, 0, 0)`;
          slides.forEach((slide, slideIndex) => {
            slide.setAttribute('aria-hidden', slideIndex === index ? 'false' : 'true');
          });
          dots.forEach((dot, dotIndex) => {
            const active = dotIndex === index;
            dot.classList.toggle('is-active', active);
            dot.setAttribute('aria-current', active ? 'true' : 'false');
          });
          if (shouldSchedule) schedule();
        };

        dots.forEach((dot) => {
          dot.addEventListener('click', () => show(Number(dot.dataset.ngDot) || 0));
        });

        carousel.addEventListener('pointerdown', (event) => {
          pointerStart = event.clientX;
          paused = true;
          stop();
        }, { passive: true });

        carousel.addEventListener('pointerup', (event) => {
          if (pointerStart !== null) {
            const distance = event.clientX - pointerStart;
            if (Math.abs(distance) > 42) show(index + (distance < 0 ? 1 : -1), false);
          }
          pointerStart = null;
          paused = false;
          schedule();
        }, { passive: true });

        carousel.addEventListener('pointercancel', () => {
          pointerStart = null;
          paused = false;
          schedule();
        });
        carousel.addEventListener('mouseenter', () => { paused = true; stop(); });
        carousel.addEventListener('mouseleave', () => { paused = false; schedule(); });
        carousel.addEventListener('focusin', () => { paused = true; stop(); });
        carousel.addEventListener('focusout', () => { paused = false; schedule(); });
        document.addEventListener('visibilitychange', schedule);
        reducedMotion.addEventListener?.('change', schedule);

        if ('IntersectionObserver' in window) {
          const carouselObserver = new IntersectionObserver((entries) => {
            visible = entries[0].isIntersecting;
            if (visible) schedule();
            else stop();
          }, { threshold: 0.2 });
          carouselObserver.observe(carousel);
        } else {
          visible = true;
        }

        show(0);
      });

      const form = root.querySelector('.twc-ng__product-form');
      const offer = root.querySelector('[data-ng-offer]');
      const sticky = root.querySelector('[data-ng-sticky]');
      const variantInput = root.querySelector('[data-ng-variant-input]');
      const variantButtons = [...root.querySelectorAll('[data-ng-variant]')];
      const price = root.querySelector('[data-ng-current-price]');
      const priceNote = root.querySelector('[data-ng-price-note]');
      const buttonPrice = root.querySelector('[data-ng-button-price]');
      const stickyPrice = root.querySelector('[data-ng-sticky-price]');
      const railPrice = root.querySelector('[data-ng-rail-price]');
      const checkoutButton = root.querySelector('[data-ng-checkout]');
      const mainImage = root.querySelector('[data-ng-main-image]');
      const gallery = root.querySelector('[data-ng-gallery]');
      const galleryChoices = [...root.querySelectorAll('[data-ng-gallery-choice]')];
      let selectedIndex = 0;
      let galleryPointerStart = null;

      const updateGallery = (index, imageSource, altText) => {
        if (!mainImage || !imageSource) return;
        mainImage.classList.add('is-changing');
        window.setTimeout(() => {
          mainImage.src = imageSource;
          mainImage.alt = altText || '';
          mainImage.classList.remove('is-changing');
        }, reducedMotion.matches ? 0 : 120);
        galleryChoices.forEach((choice, choiceIndex) => {
          const active = choiceIndex === index;
          choice.classList.toggle('is-active', active);
          choice.setAttribute('aria-current', active ? 'true' : 'false');
        });
      };

      const selectVariant = (nextIndex) => {
        const button = variantButtons[nextIndex];
        if (!button || button.disabled) return;
        selectedIndex = nextIndex;
        variantButtons.forEach((variantButton, index) => {
          const active = index === selectedIndex;
          variantButton.classList.toggle('is-selected', active);
          variantButton.setAttribute('aria-pressed', active ? 'true' : 'false');
        });
        if (variantInput) variantInput.value = button.dataset.id;
        if (price) price.textContent = button.dataset.price;
        if (priceNote) priceNote.textContent = button.dataset.note;
        if (buttonPrice) buttonPrice.textContent = button.dataset.price;
        if (stickyPrice) stickyPrice.textContent = button.dataset.price;
        if (railPrice) railPrice.textContent = button.dataset.price;
        if (checkoutButton) checkoutButton.disabled = false;
        updateGallery(selectedIndex, button.dataset.image, button.dataset.alt);
      };

      variantButtons.forEach((button, index) => {
        button.addEventListener('click', () => selectVariant(index));
      });
      galleryChoices.forEach((choice, index) => {
        choice.addEventListener('click', () => selectVariant(index));
      });

      if (gallery) {
        gallery.addEventListener('pointerdown', (event) => {
          galleryPointerStart = event.clientX;
        }, { passive: true });
        gallery.addEventListener('pointerup', (event) => {
          if (galleryPointerStart === null) return;
          const distance = event.clientX - galleryPointerStart;
          if (Math.abs(distance) > 42) selectVariant(distance < 0 ? 1 : 0);
          galleryPointerStart = null;
        }, { passive: true });
        gallery.addEventListener('pointercancel', () => {
          galleryPointerStart = null;
        });
      }

      if (form && checkoutButton && variantInput) {
        form.addEventListener('submit', (event) => {
          event.preventDefault();
          if (!variantInput.value || checkoutButton.disabled) return;
          const label = checkoutButton.querySelector('span');
          const originalLabel = label?.textContent || '';
          checkoutButton.disabled = true;
          if (label) label.textContent = 'Adding selected offer…';

          fetch(root.dataset.cartAddUrl, {
            method: 'POST',
            credentials: 'same-origin',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ id: Number(variantInput.value), quantity: 1 })
          })
            .then((response) => {
              if (!response.ok) throw new Error('Cart request failed');
              return response.json();
            })
            .then(() => window.location.assign(root.dataset.checkoutUrl))
            .catch(() => {
              checkoutButton.disabled = false;
              if (label) label.textContent = originalLabel;
              form.submit();
            });
        });
      }

      if (form && sticky && 'IntersectionObserver' in window) {
        const offerObserver = new IntersectionObserver((entries) => {
          const formVisible = entries[0].isIntersecting;
          sticky.classList.toggle('is-offer-visible', formVisible);
          sticky.setAttribute('aria-hidden', formVisible ? 'true' : 'false');
          if (formVisible) sticky.setAttribute('inert', '');
          else sticky.removeAttribute('inert');
        }, { threshold: 0.12, rootMargin: '-24px 0px -24px' });
        offerObserver.observe(form);
      }

      if (offer && window.location.hash === `#${offer.id}`) {
        window.requestAnimationFrame(() => offer.scrollIntoView({ block: 'start' }));
      }

      selectVariant(0);
    };

    const initializeAll = () => document.querySelectorAll(selector).forEach(initialize);
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initializeAll, { once: true });
    } else {
      initializeAll();
    }
    document.addEventListener('shopify:section:load', initializeAll);
    document.addEventListener('shopify:section:unload', () => {
      window.requestAnimationFrame(() => {
        if (!document.querySelector(selector)) document.body.classList.remove('twc-ng-landing-active');
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nail-clipper-page"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const host = document.querySelector('#nail-clipper-page-host');
    if (!host) return;

    const root = host.querySelector('#grinder-landing');
    if (!root) {
      host.classList.add('is-ready');
      return;
    }

    const sourceBrand = root.querySelector('.gl-logo');
    if (sourceBrand) {
      sourceBrand.remove();
    }

    while (host.firstChild && host.firstChild !== root) {
      host.firstChild.remove();
    }

    const form = root.querySelector('.gl-product-form');
    const variantInput = root.querySelector('#gl-variant-id');
    const variantButtons = [...root.querySelectorAll('.gl-variant')];
    const buyOne = {
      id: host.dataset.buyOneId,
      price: host.dataset.buyOnePrice,
      available: host.dataset.buyOneAvailable === 'true'
    };
    const buyTwo = {
      id: host.dataset.buyTwoId,
      price: host.dataset.buyTwoPrice,
      available: host.dataset.buyTwoAvailable === 'true'
    };

    const patchVariant = (button, variant) => {
      if (!button) return;
      button.dataset.id = variant.id;
      button.dataset.price = variant.price;
      button.disabled = !variant.available;
      const buttonPrice = button.querySelector(':scope > strong');
      if (buttonPrice) buttonPrice.textContent = variant.price;
    };

    patchVariant(variantButtons[0], buyOne);
    patchVariant(variantButtons[1], buyTwo);

    const heroGrid = root.querySelector('.gl-hero-grid');
    const heroProduct = root.querySelector('.gl-hero-product');
    const heroTitle = root.querySelector('.gl-hero-copy h1');
    const featureStrip = root.querySelector('.gl-feature-strip');
    const giftSection = root.querySelector('.gl-gift');
    const offerSection = root.querySelector('.gl-offer-section');
    const bundleBanner = root.querySelector('.gl-bundle-banner');
    const mobileLayout = window.matchMedia('(max-width: 749px)');
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

    if (giftSection && offerSection) {
      offerSection.classList.remove('is-mobile-priority');
      if (bundleBanner) {
        giftSection.insertAdjacentElement('afterend', bundleBanner);
        bundleBanner.insertAdjacentElement('afterend', offerSection);
      } else {
        giftSection.insertAdjacentElement('afterend', offerSection);
      }
    }

    const makeImage = (source, alt) => {
      const image = document.createElement('img');
      image.src = source;
      image.alt = alt;
      image.loading = 'lazy';
      image.decoding = 'async';
      return image;
    };

    const addHeroOrnament = (source, modifier) => {
      if (!heroTitle || !source || heroTitle.querySelector(`.gl-hero-ornament--${modifier}`)) return;
      const image = document.createElement('img');
      image.src = source;
      image.alt = '';
      image.loading = 'eager';
      image.decoding = 'async';
      image.fetchPriority = 'high';
      image.setAttribute('aria-hidden', 'true');
      image.className = `gl-hero-ornament gl-hero-ornament--${modifier}`;
      heroTitle.append(image);
    };

    addHeroOrnament(host.dataset.heroProduct, 'product');
    addHeroOrnament(host.dataset.heroSparkle, 'sparkle');
    addHeroOrnament(host.dataset.heroFinger, 'finger');

    const setupAutoCarousel = (container, slides, options) => {
      if (!container || slides.length < 2 || container.dataset.carouselReady === 'true') return;
      container.dataset.carouselReady = 'true';
      container.classList.add('gl-auto-carousel', options.className);
      container.setAttribute('role', 'region');
      container.setAttribute('aria-roledescription', 'carousel');
      container.setAttribute('aria-label', options.label);

      const track = document.createElement('div');
      track.className = 'gl-auto-track';
      track.setAttribute('aria-live', 'off');
      slides.forEach((slide) => {
        slide.classList.add('gl-auto-slide');
        track.append(slide);
      });
      container.replaceChildren(track);

      let dots = [];
      if (options.dots && !reducedMotion.matches) {
        const dotWrap = document.createElement('div');
        dotWrap.className = 'gl-auto-dots';
        dots = slides.map((slide, index) => {
          const dot = document.createElement('button');
          dot.type = 'button';
          dot.className = 'gl-auto-dot';
          dot.setAttribute('aria-label', `Show ${options.label} slide ${index + 1}`);
          dot.addEventListener('click', () => showSlide(index));
          dotWrap.append(dot);
          return dot;
        });
        container.append(dotWrap);
      }

      let activeIndex = 0;
      let timer = null;
      let isVisible = false;
      let pointerStart = null;

      const stop = () => {
        if (timer) window.clearInterval(timer);
        timer = null;
      };

      const start = () => {
        stop();
        if (!isVisible || reducedMotion.matches || document.hidden) return;
        timer = window.setInterval(() => showSlide(activeIndex + 1), options.delay || 2000);
      };

      function showSlide(nextIndex) {
        activeIndex = (nextIndex + slides.length) % slides.length;
        track.style.transform = `translate3d(-${activeIndex * 100}%, 0, 0)`;
        slides.forEach((slide, index) => slide.setAttribute('aria-hidden', index === activeIndex ? 'false' : 'true'));
        dots.forEach((dot, index) => {
          dot.classList.toggle('is-active', index === activeIndex);
          dot.setAttribute('aria-current', index === activeIndex ? 'true' : 'false');
        });
        start();
      }

      if (reducedMotion.matches) {
        container.classList.add('is-static');
        slides.forEach((slide) => slide.setAttribute('aria-hidden', 'false'));
        return;
      }

      showSlide(0);
      container.addEventListener('pointerdown', (event) => {
        pointerStart = event.clientX;
        stop();
      }, { passive: true });
      container.addEventListener('pointerup', (event) => {
        if (pointerStart !== null) {
          const distance = event.clientX - pointerStart;
          if (Math.abs(distance) > 42) showSlide(activeIndex + (distance < 0 ? 1 : -1));
        }
        pointerStart = null;
        start();
      }, { passive: true });
      container.addEventListener('focusin', stop);
      container.addEventListener('focusout', start);
      document.addEventListener('visibilitychange', start);

      if ('IntersectionObserver' in window) {
        const visibilityObserver = new IntersectionObserver((entries) => {
          isVisible = entries[0].isIntersecting;
          if (isVisible) start();
          else stop();
        }, { threshold: 0.2 });
        visibilityObserver.observe(container);
      } else {
        isVisible = true;
        start();
      }
    };

    const buildMobileCarousels = () => {
      if (!mobileLayout.matches) return;

      if (heroGrid && heroProduct && featureStrip && featureStrip.dataset.carouselReady !== 'true') {
        heroGrid.append(featureStrip);
        const features = [...featureStrip.children];
        if (features.length >= 4) {
          const featureSlides = [0, 2].map((startIndex) => {
            const slide = document.createElement('div');
            features.slice(startIndex, startIndex + 2).forEach((feature) => slide.append(feature));
            return slide;
          });
          setupAutoCarousel(featureStrip, featureSlides, {
            className: 'gl-feature-carousel',
            label: 'Standout features',
            dots: false,
            delay: 3500
          });
        }
      }

      const ageCaptions = root.querySelectorAll('.gl-age-grid figcaption');
      ['Gear 1 For Baby', 'Gear 2 For Adult', 'Gear 3 For Senior'].forEach((label, index) => {
        if (ageCaptions[index]) ageCaptions[index].textContent = label;
      });

      const results = root.querySelector('.gl-before-after');
      if (results && results.dataset.carouselReady !== 'true') {
        const resultSets = [
          [
            [host.dataset.resultHandOne, 'Hand nails before and after smoothing'],
            [host.dataset.resultFootOne, 'Toenails before and after smoothing']
          ],
          [
            [host.dataset.resultHandTwo, 'Second hand nail before and after result'],
            [host.dataset.resultFootTwo, 'Second toenail before and after result']
          ]
        ];
        const resultSlides = resultSets.map((set) => {
          const slide = document.createElement('div');
          slide.className = 'gl-results-slide';
          set.forEach(([source, alt]) => {
            const figure = document.createElement('figure');
            figure.append(makeImage(source, alt));
            [
              ['Before', 'gl-result-label gl-result-label--before'],
              ['VS', 'gl-result-vs'],
              ['After', 'gl-result-label gl-result-label--after']
            ].forEach(([label, className]) => {
              const overlay = document.createElement('span');
              overlay.textContent = label;
              overlay.className = className;
              overlay.setAttribute('aria-hidden', 'true');
              figure.append(overlay);
            });
            slide.append(figure);
          });
          return slide;
        });
        setupAutoCarousel(results, resultSlides, {
          className: 'gl-results-carousel',
          label: 'Before and after results',
          dots: true
        });
      }

      const techGrid = root.querySelector('.gl-tech-grid');
      if (techGrid && techGrid.dataset.carouselReady !== 'true') {
        setupAutoCarousel(techGrid, [...techGrid.children], {
          className: 'gl-tech-carousel',
          label: 'Product technology highlights',
          dots: true
        });
      }
    };

    const giftGrid = giftSection?.querySelector('.gl-gift-grid');
    if (giftSection && giftGrid && !giftGrid.classList.contains('is-reference-layout')) {
      const giftHeading = giftSection.querySelector('.gl-section-heading h2');
      if (giftHeading) giftHeading.textContent = 'Thoughtful & Practical Gift';

      const recipients = document.createElement('div');
      recipients.className = 'gl-gift-recipients';
      [
        [host.dataset.giftChild, 'Child receiving a thoughtful gift', 'Kids'],
        [host.dataset.giftLady, 'Woman receiving a thoughtful gift', 'Her'],
        [host.dataset.giftParents, 'Parent receiving a practical gift', 'Parents']
      ].forEach(([source, alt, label]) => {
        const figure = document.createElement('figure');
        figure.className = 'gl-gift-recipient';
        figure.append(makeImage(source, alt));
        const caption = document.createElement('figcaption');
        caption.textContent = label;
        figure.append(caption);
        recipients.append(figure);
      });

      const specList = document.createElement('ul');
      specList.className = 'gl-gift-spec-list';
      [
        ['Speed Settings (3 Levels)', 'Low · Medium · High'],
        ['Continuous Working Time', '>4 hours for 40+ consecutive trims'],
        ['Standby Time', '6 months · Weight: 45g'],
        ['Battery & Body', 'Built-in lithium battery · ABS material'],
        ['Rated Input & Noise', '5V/0.4A · ≤25dB'],
        ['Package Includes', 'Main unit, detachable grinding head and USB-C cable']
      ].forEach(([title, detail]) => {
        const item = document.createElement('li');
        const strong = document.createElement('strong');
        strong.textContent = `${title}: `;
        item.append(strong, detail);
        specList.append(item);
      });

      const oldSpecs = giftGrid.querySelector('.gl-specs');
      giftGrid.prepend(recipients);
      if (oldSpecs) oldSpecs.replaceWith(specList);
      else giftGrid.append(specList);
      giftGrid.classList.add('is-reference-layout');
    }

    buildMobileCarousels();

    const galleryThumbs = [...root.querySelectorAll('.gl-thumbs button')];
    const buyTwoThumb = galleryThumbs[1];
    if (buyTwoThumb) {
      const needsCacheOverride = buyTwoThumb.dataset.image !== host.dataset.buyTwoImage;
      buyTwoThumb.dataset.image = host.dataset.buyTwoImage;
      const buyTwoThumbImage = buyTwoThumb.querySelector('img');
      if (buyTwoThumbImage) buyTwoThumbImage.src = host.dataset.buyTwoImage;

      if (needsCacheOverride) {
        variantButtons.forEach((button, index) => {
          button.addEventListener('click', () => galleryThumbs[index]?.click());
        });
      }
    }

    if (form) {
      form.action = host.dataset.cartAddUrl;
      const productTitle = form.querySelector(':scope > h2');
      if (productTitle) productTitle.textContent = host.dataset.productTitle;
    }

    if (variantInput) variantInput.value = buyOne.id;

    const currentPrice = root.querySelector('#gl-price');
    const buyNowPrice = root.querySelector('#gl-buy-now-price');
    const stickyPrice = root.querySelector('#gl-sticky-price');
    if (currentPrice) currentPrice.textContent = buyOne.price;
    if (buyNowPrice) buyNowPrice.textContent = buyOne.price;
    if (stickyPrice) stickyPrice.textContent = buyOne.price;

    const mobileSticky = root.querySelector('.gl-mobile-sticky');
    if (form && mobileSticky && 'IntersectionObserver' in window) {
      const offerVisibility = new IntersectionObserver((entries) => {
        mobileSticky.classList.toggle('is-offer-visible', entries[0].isIntersecting);
      }, { threshold: 0.12 });
      offerVisibility.observe(form);
    }

    root.dataset.productUrl = host.dataset.productUrl;
    host.classList.add('is-ready');
  })();

  } catch(e) { console.error(e); }
})();
})();
